import React, { useContext, useState } from 'react';
import { Student } from '../../../types/Student';
import Dropdown from '@/components/ui/Dropdown';

import useSWRMutation from 'swr/mutation';

import { StudentsResponse, addStudentToWallOfFame, removeStudentFromWallOfFame } from '@/lib/Students';
import { KeyedMutator } from 'swr';
import Loading from '@/components/ui/Loading';
import SharedDialog from '../SharedDialog';
import { AppProvider } from '@/context/AppProvider';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'ntml-button': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & { class?: string };
    }
  }
}

const SubmissionCard = React.memo(
  ({ user, token, mutate, dropDown, addStudentButton }: { user: Student; token: string; mutate: KeyedMutator<unknown>; dropDown: boolean; addStudentButton: boolean }) => {
    const { masteryCardLabel, masteryCardPopupLabel } = useContext(AppProvider);
    const [selectedValue, setSelectedValue] = useState({ id: 0, item: '' });
    const { trigger: addStudentTrigger, isMutating: isStudentAdded } = useSWRMutation('/wp-json/wall-of-fame/v1/submissions', addStudentToWallOfFame);
    const { trigger: removeStudentTrigger, isMutating: isStudentRemoved } = useSWRMutation(`/wp-json/wall-of-fame/v1/submissions/`, removeStudentFromWallOfFame);

    const handleAddStudent = async ({ studentId }: { studentId: number }) => {
      const topicValue = selectedValue.item.toString();
      if (!topicValue || !topicValue.trim()) {
        alert('Please select the appropriate Drill Team program.');
        return;
      }
      await addStudentTrigger({
        studentId: studentId.toString(),
        token,
        topic: topicValue,
      }).then(() =>
        mutate((response: StudentsResponse) => {
          const updatedStudents = response.data.map((student) => {
            if (studentId === student.ID) {
              return {
                ...student,
                topic: topicValue,
                isAdded: '1',
              };
            }
            return student;
          });

          return {
            data: updatedStudents,
            enrolled_count: response.enrolled_count,
            total: response.total,
          };
        }, false)
      );
    };
    const handleRemoveStudent = async (student: Student) => {
      await removeStudentTrigger({
        studentId: student.ID.toString(),
        token,
      }).then(() =>
        mutate((response: StudentsResponse) => {
          setSelectedValue({ id: 0, item: '' });
          const updatedData = response.data.map((studentData) => {
            if (student.ID === studentData.ID) {
              return {
                ...studentData,
                topic: '',
                isAdded: '0',
              };
            }
            return studentData;
          });

          return {
            data: updatedData,
            enrolled_count: response.enrolled_count,
            total: response.total,
          };
        }, false)
      );
    };

    const today = new Date();
    // const todayDay = new Date().getDay();
    const activationDate = new Date('2024-06-17');

    return (
      <div className='flex justify-center flex-col bg-white rounded-xl p-3 border border-[#EAECF0] text-center'>
        <div className='text-center'>
          <img src={user.avatar_url} alt={user.user_login} width={85} height={85} className='rounded-lg mx-auto' />
        </div>
        <h2 className='font-semibold text-2xl text-black mt-3 mb-0'>{user.user_login}</h2>
        {today >= activationDate && dropDown && <Dropdown id={user.ID} setSelectedValue={setSelectedValue} studentTopic={user.topic || ''} disabled={user.isAdded === '1'} />}
        {today >= activationDate && addStudentButton ? (
          isStudentAdded || isStudentRemoved ? (
            <ntml-button class='bg-white text-black w-fit mx-auto h-[44px] mt-3'>
              <div className='flex flex-row gap-4'>
                {isStudentAdded ? (
                  <>
                    Submitting <Loading />
                  </>
                ) : (
                  <>
                    Removing <Loading />
                  </>
                )}
              </div>
            </ntml-button>
          ) : (
            <div className='w-full mx-auto mt-3 flex justify-center'>
              {user.isAdded === '1' ? (
                <ntml-button onClick={() => handleRemoveStudent(user)} class='remove-btn bg-[#FEF3F2] w-full text-[#B42318] text-base font-semibold px-2 py-2.5 rounded-lg hover:bg-[#ffbdb8] hover:shadow-sm transition-colors flex justify-center items-center gap-1'>
                  <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M13.8332 15H18.8332M10.4998 12.9167H6.74984C5.58687 12.9167 5.00538 12.9167 4.53222 13.0602C3.46688 13.3834 2.6332 14.217 2.31004 15.2824C2.1665 15.7555 2.1665 16.337 2.1665 17.5M12.5832 6.25C12.5832 8.32107 10.9042 10 8.83317 10C6.7621 10 5.08317 8.32107 5.08317 6.25C5.08317 4.17893 6.7621 2.5 8.83317 2.5C10.9042 2.5 12.5832 4.17893 12.5832 6.25Z'
                      stroke='#B42318'
                      strokeWidth='1.66667'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                  Remove
                </ntml-button>
              ) : (
                // : todayDay == 0 || todayDay == 6 ? (
                //   <div className='bg-gray-200 text-black font-normal text-base px-2 py-2.5 rounded-lg w-full cursor-not-allowed'>{DISABLED_BUTTON}</div>
                // )
                <ntml-button
                  onClick={() =>
                    handleAddStudent({
                      studentId: user.ID,
                    })
                  }
                  class='submit-btn bg-[#9090f3] hover:bg-[#3333FF] w-full text-white text-base font-semibold px-2 py-2.5 rounded-lg transition-colors flex justify-center items-center gap-3'
                >
                  Submit
                  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M3.3335 10H16.6668M16.6668 10L11.6668 5M16.6668 10L11.6668 15' stroke='white' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round' />
                  </svg>
                </ntml-button>
              )}
            </div>
          )
        ) : (
          <>
            <div className={`video-wrapper pt-3 ${today < activationDate ? '' : 'hidden'}`}>Starts on June 17</div>
          </>
        )}
        <div className={`video-wrapper pt-1 ${today < activationDate ? 'hidden' : ''}`}>
          <h3 className=' text-lg font-normal'>{dropDown ? '' : user?.topic || masteryCardLabel}</h3>
          <SharedDialog studentId={user.ID} token={token} pathName={dropDown ? 'drill-topics' : 'mastered-topics'} label={masteryCardPopupLabel} />
        </div>
        <p className='text-xs text-gray-400'>{user.location}</p>
      </div>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.user.isAdded == nextProps.user.isAdded && prevProps.user.topic == nextProps.user.topic && prevProps.user.ID == nextProps.user.ID;
  }
);

export default SubmissionCard;
